import React from 'react';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { CmsEntities } from 'client/data/models/cms';
import { DEFAULT_CONTENT } from 'client/data/cms/content';
import { Link } from 'site-modules/shared/components/link/link';

export function EditorCard({ editor = DEFAULT_CONTENT }) {
  const { title, summary } = editor;
  const { aboutLink, instagramLink, twitterLink, linkedInLink, youtubeLink, facebookLink, position, photoLink } =
    editor.getAllMetadata();

  const socialLinks = [
    { icon: 'icon-instagram', iconTitle: 'Instagram', link: instagramLink },
    { icon: 'icon-twitter', iconTitle: 'Twitter', link: twitterLink },
    { icon: 'icon-linkedin', iconTitle: 'LinkedIn', link: linkedInLink },
    { icon: 'icon-play', iconTitle: 'YouTube', link: youtubeLink },
    { icon: 'icon-facebook2', iconTitle: 'Facebook', link: facebookLink },
  ].filter(({ link }) => link);

  return (
    <Row tag="section" className="editor-card">
      <Col xs={12} lg={4} className="text-center">
        <img src={photoLink} alt={title} className="rounded mb-1 mb-lg-0 mw-100" />
      </Col>
      <Col xs={12} lg={8}>
        <h3 className="size-16">
          {aboutLink ? (
            <Link to={aboutLink} className="text-primary-darker">
              {title}
            </Link>
          ) : (
            title
          )}
          , {position}
        </h3>
        <p className="size-16">{summary}</p>
        <div className="d-flex">
          {socialLinks.map(({ iconTitle, icon, link }) => (
            <Link
              key={icon}
              to={link}
              title={`${title}'s ${iconTitle}`}
              aria-label={`${title}'s ${iconTitle}`}
              className="me-1"
            >
              <span className={`${icon} size-18 text-primary-darker`} aria-hidden />
            </Link>
          ))}
        </div>
      </Col>
    </Row>
  );
}

EditorCard.propTypes = {
  editor: CmsEntities.Content,
};
